import { client } from './api'
import { UserRestrictionsData } from '../types/userRestrictions'

/**
 * Fetch user restrictions from the backend
 * Returns restriction status and configuration for the current user
 */
export async function getUserRestrictions(): Promise<UserRestrictionsData> {
  return await client.doGet('/wallet/user/restrictions') as UserRestrictionsData
}
